import styled from "styled-components";
import PropTypes from "prop-types";

const View = styled.div`
  display: grid;
  fieldset {
    margin-top: 7px;
    legend {
      font-family: "Metropolis";
      font-size: 16px;
      padding: 10px 0;
      margin-bottom: 10px;
      border-bottom: 3px solid ${(props) => props.theme.blue_g};
      text-transform: none;
      span {
        font-size: 12px;
        line-height: 30px;
        margin: 15px;
        input[type="checkbox"] {
          margin-right: 5px;
        }
      }
      .status-badge {
        position: absolute;
        right: 15px;
        top: 15px;
        padding: 12px 10px !important;
        line-height: 0;
      }
    }
  }
  .image-container {
    height: 200px;
    width: 200px;
    margin: 15px 0;
    grid-area: image;
    border-radius: 5px;
    box-shadow: 0 3px 5px rgba(34, 34, 34, 0.1);
  }
  .data-container {
    width: auto;
    grid-area: data;
    display: grid;
    grid-template-columns: 1fr 1fr;
    font-family: "Nunito";
    .data {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      margin: 10px 0;
      label {
        margin: 0;
        font-weight: 400;
        font-size: 11px;
        text-transform: uppercase;
        color: "#aaa";
      }
      span {
        font-weight: 700;
      }
    }
  }
  .data-container-collection {
    width: auto;
    grid-area: data;
    display: flex;
    justify-content: space-between;
    grid-template-columns: 1fr 1fr;
    font-family: "Nunito";
    .data {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      margin: 10px 0;
      label {
        margin: 0;
        font-weight: 400;
        font-size: 11px;
        text-transform: uppercase;
        color: #aaa;
      }
      span {
        font-weight: 700;
      }
    }
  }

  .data-container-single {
    width: auto;
    grid-area: data;
    display: grid;
    grid-template-columns: 1fr;
    font-family: "Nunito";
    .data {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      margin: 10px 0;
      label {
        margin: 0;
        font-weight: 400;
        font-size: 11px;
        text-transform: uppercase;
        color: #aaa;
      }
      span {
        font-weight: 700;
      }
    }
  }
  @media screen and (max-width: 769px) {
    padding: 0 15px;
  }
`;

export default View;

View.propTypes = {
  theme: PropTypes.object
};
